import React, { useRef } from "react";
import { useState, useEffect, useContext } from "react";
import {
  Button,
  MenuItem,
  FormControl,
  Select,
  SelectChangeEvent,
  InputLabel,
  Pagination,
} from "@mui/material";
import { OidcIdentityContext } from "@rsmus/react-auth/dist/OidcIdentity";
import { taxPortalClientApi,createSitesClientApi, userAssignmentClientApi, customPermissionClientApi } from "../../api-client-nswag/taxportal-client-runtime";
import {
  DataGrid,
  Column,
  FilterRow,
  HeaderFilter,
  LoadPanel,
  Scrolling,
  SearchPanel,
  Paging,
  Selection,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
import { calculateGridHeight, convertUTCTimeToLocal } from "../../util/Utils";
import { dataGridConfig, defaultPageSize } from "../../constants";
import "./SiteAdminAccess.scss";
import {
  atom,
  useRecoilState,
  useRecoilValue,
  useSetRecoilState,
} from "recoil";
import { SiteUpdate } from "../UpdateScreen/UpdateSiteInfoAtoms";
import { snackbarState } from "../../cui/commonComponents/CustomSnackbar";
import {
  GetAllRolesDTO,
  ServiceMessage,
  GetAllSitesInfoDTO,
  SelectCustomPermission,
  SelectName,
  SelectCustomPermissionIsheetType,
} from "../../api-client-nswag/taxportal-client";
import {
  GetAllSitesDTO,
  ServiceBusEnum
} from "../../api-client-nswag/taxportal-client";
import {SyncTypeEnum} from "../../api-client-nswag/create-sites-client";
import { RoleId } from "./SiteAdmin.types";
import SplitButton from "./SplitButton";
import SplitButtonApplication from "./SplitButtonApplication";
import {isEmpty, isNull } from "lodash";
import AppNameToggle, {
  getAppName,
} from "../../cui/commonComponents/AppNameToggle";
import NestedDropDown from "../../cui/commonComponents/NestedDropDown";
import useSnackbar from "../../hooks/useSnackbar";
import { SnackbarMessage } from "../../hooks/useSnackbar.types";
import NestedDropDownV2 from "../../cui/commonComponents/NestedDropDownV2";
import { UserAssignTpac, TpacRequestBasicMessage, UserAssignmentCEMAction } from "../../api-client-nswag/userassignment-client";

type DatagridRefType = DataGrid;

export const type = atom({
  key: "SyncType",
  default: SyncTypeEnum.SITE_ADMIN_ACCESS,
});
const appPermissionMap: Record<string, (keyof typeof SelectCustomPermission)[]> = {
  CS: ["CUSTOM_GROUPS",
    "INFORMATION_REQUEST",
    "PROJECT_STATUS",
    "UPDATE_IRVIEW_PERMISSIONS",
    "UPDATE_PSVIEW_PERMISSIONS",
    "UPDATE_FOLDER_PERMISSIONS",
    "EMAIL_FAILURE"],
  TP: ["CUSTOM_GROUPS",
    "INFORMATION_REQUEST",
    "PROJECT_STATUS",
    "UPDATE_IRVIEW_PERMISSIONS",
    "UPDATE_PSVIEW_PERMISSIONS",
    "UPDATE_FOLDER_PERMISSIONS",
    "EMAIL_FAILURE",
    "K1_TRACKER",
    "UPDATE_DELIVERABLES",
    "UPDATE_K1_TRACKER_PERMISSIONS",
    "UPDATE_DELIVERABLES_PERMISSIONS"],
  PERF: ["CUSTOM_GROUPS",
    "INFORMATION_REQUEST",
    "PROJECT_STATUS",
    "UPDATE_IRVIEW_PERMISSIONS",
    "UPDATE_PSVIEW_PERMISSIONS",
    "UPDATE_FOLDER_PERMISSIONS",
    "EMAIL_FAILURE"]
}
const SiteAdminAccess = () => {
  const [data, setData] = useRecoilState(SiteUpdate);
  const [searchTerm, setSearchTerm] = useState<string | null | undefined>(null);
  const [rolesData, setRolesData] = useState<GetAllRolesDTO[]>([]);
  const { user } = useContext(OidcIdentityContext);
//   const [selectedRows, setSelectedRows] = useState([]);
  const setSnackbar = useSetRecoilState(snackbarState);
  const dataGridRef = useRef<DatagridRefType>(null);
  const appName = useRecoilValue(getAppName);
  const [pageNumber, setpageNumber] = useState(1);
  const [syncType, setSyncType] = useRecoilState(type);
  const [dropDown, setDropDown] = useState("");
  const { showSnackbar, showSuccessSnackbar } = useSnackbar();
  const [setsyncTypeIs, setSetsyncTypeIs] = useState(SyncTypeEnum.TESS_ISHEET_ASSIGNMENT)
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([]);
    const [selectedData, setSelectedData] = useState<any>([]);
    const prevKeysRef = useRef<any>([]);
    const prevDataRef = useRef<any>([]);

  const getPermissionsByApp = (appName: string): SelectCustomPermission[] => {
    const keys = appPermissionMap[appName] || [];
    return keys.map((key) => SelectCustomPermission[key]);
  }
  const OLD_FLOW_LABEL = "Old Flow";
  const NEW_FLOW_LABEL = "New Flow";
  const NEW_FLOW_OPTIONS = ["Create Custom Groups and Add Users",
    "Apply Folder Permissions","Create IR views and add navigation",
    "Apply IR Permissions",
    "Create PS views and add navigation",
    "Apply PS Permissions",
    "Create K1 Tracker Views and add navigation",
    "Apply K1 Tracker Permissions",
    "Create Deliverable Views and add navigation",
    "Apply Deliverables Permissions",
    "Send Email for failures and successes",
    "Apply All Custom Permissions"];
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const rolesData: GetAllRolesDTO[] =
          await taxPortalClientApi.taxPortal_GetAllRoles();
        if (!isNull(rolesData) && !isEmpty(rolesData)) {
          const filteredDataCS: GetAllRolesDTO[] = rolesData
            .filter((item) =>
              item?.name?.startsWith("CS"))
            .map(item => ({
              ...item,
              displayName: item?.name?.replace("CS - ", "")
            }));
          const filteredDataTP: GetAllRolesDTO[] = rolesData.filter(
            (item) => !item?.name?.startsWith("CS")
          ).map(item => ({
            ...item,
            displayName: item?.name
          }));
          if (appName === "CS") {
            setRolesData(filteredDataCS);
          } else if (appName === "TP") {
            setRolesData(filteredDataTP);
          }
        }
      } catch (error) { }
    };
    fetchRoles();
  }, [appName]);

  const fetchSites = async () => {
    try {
      setData({ pending: true, fulfilled: true, sites: [], totalCount: 0 });
      const startIndex =
        pageNumber === 1 ? 0 : (pageNumber - 1) * defaultPageSize;
      const data = await createSitesClientApi.taxPortal_GetAllSites(
        appName === "IS" ? setsyncTypeIs : syncType,
        null,
        appName !== null ? appName : "PERF",
        startIndex,
        defaultPageSize
      );

      setData({
        pending: false,
        fulfilled: true,
        sites: data.data,
        totalCount: data.totalCount,
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (searchTerm === null || searchTerm?.length === 0) {
      fetchSites();
    }
  }, [pageNumber, appName, searchTerm]);
  const handleClick = async () => {
    const message = selectedData.map((e: any) => {
      return {
        siteId: e.hqSiteId,
        userName: user?.profile.preferred_username,
        eventType: ServiceBusEnum.SITE_ADMIN_ACCESS,
      };
    });
    try {
      setSnackbar({
        open: true,
        message: "Provide Content Admin access in Progress.",
        severity: "info",
      });
      await taxPortalClientApi.taxPortal_InsertTopic(message);
      clearSelection();
    } catch (error) {
      console.log(error);
    }
  };
const isPartitionLabel = (val: string) => val === OLD_FLOW_LABEL || val === NEW_FLOW_LABEL;

const handleUpdateClick = async (): Promise<void> => {
    try {
      const dropDownSelect: Record<string, ServiceBusEnum> = {
        [SelectCustomPermission.CUSTOM_GROUPS]: ServiceBusEnum.UPDATE_CUSTOM_GROUPS,
        [SelectCustomPermission.INFORMATION_REQUEST]: ServiceBusEnum.UPDATE_VIEWS,
        [SelectCustomPermission.PROJECT_STATUS]: ServiceBusEnum.UPDATE_VIEWS,
        [SelectCustomPermission.K1_TRACKER]: ServiceBusEnum.UPDATE_VIEWS,
        [SelectCustomPermission.UPDATE_DELIVERABLES]: ServiceBusEnum.UPDATE_VIEWS,
      };
      const iSheetTypeSelect: Record<string, SelectCustomPermissionIsheetType> = {
        [SelectCustomPermission.INFORMATION_REQUEST]: SelectCustomPermissionIsheetType.InformationRequest,
        [SelectCustomPermission.PROJECT_STATUS]: SelectCustomPermissionIsheetType.ProjectStatus,
        [SelectCustomPermission.K1_TRACKER]: SelectCustomPermissionIsheetType.K1Tracker,
        [SelectCustomPermission.UPDATE_DELIVERABLES]: SelectCustomPermissionIsheetType.Deliverables,
      };
      const selectedValue = dropDownSelect[dropDown];
      const iSheetTypeValue = iSheetTypeSelect[dropDown];
      if (selectedValue) {
        showSnackbar({ message: SnackbarMessage.CUSTOM_PERMISSIONS });

        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          const basePayload = {
            siteId: e.hqSiteId,
            userName: user?.profile.preferred_username,
            eventType: selectedValue,
            mdmClientId: e.mdmClientId,
          };
          if (dropDown !== SelectCustomPermission.CUSTOM_GROUPS) {
            return { ...basePayload, isheetType: iSheetTypeValue };
          }

          return basePayload;
        });


        await taxPortalClientApi.taxPortal_InsertTopic(data);
        clearSelection();
      }
      if (dropDown === "Apply All Custom Permissions") {
        showSnackbar({ message: "Apply All Custom Permissions triggered." as SnackbarMessage, severity: "info" });
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var CpResponse = await customPermissionClientApi.customPermission_Initiate(data[0].siteId, data[0].mdmClientId!);
        if (CpResponse.success === true) {
          showSuccessSnackbar({ message: CpResponse.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: CpResponse.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if (dropDown === "Create Custom Groups and Add Users") {
        showSnackbar({ message: "Create Custom Groups and Add Users triggered." as SnackbarMessage, severity: "info" });
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var CpODResponse = await customPermissionClientApi.customPermission_OnDemand(data[0].siteId, data[0].mdmClientId!, "CreateGroup", "All");
        if (CpODResponse.success === true) {
          showSuccessSnackbar({ message: CpODResponse.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: CpODResponse.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if( dropDown === "Apply Folder Permissions") {
        showSnackbar({ message: "Apply Folder Permissions triggered." as SnackbarMessage, severity: "info" });
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var CpFPResponse = await customPermissionClientApi.customPermission_OnDemand(data[0].siteId, data[0].mdmClientId!, "UpdateFolderPermission", "All");
        if (CpFPResponse.success === true) {
          showSuccessSnackbar({ message: CpFPResponse.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: CpFPResponse.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if( dropDown === "Create IR views and add navigation") {
        showSnackbar({ message: "Create IR views and add navigation triggered." as SnackbarMessage, severity: "info" });
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var CpIRResponse = await customPermissionClientApi.customPermission_OnDemand(data[0].siteId, data[0].mdmClientId!, "CreateView", "Information Request List");
        if (CpIRResponse.success === true) {
          showSuccessSnackbar({ message: CpIRResponse.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: CpIRResponse.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if( dropDown === "Create PS views and add navigation") {
        showSnackbar({ message: "Create PS views and add navigation triggered." as SnackbarMessage, severity: "info" });
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var CpPSResponse = await customPermissionClientApi.customPermission_OnDemand(data[0].siteId, data[0].mdmClientId!, "CreateView", "Project Status");
        if (CpPSResponse.success === true) {
          showSuccessSnackbar({ message: CpPSResponse.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: CpPSResponse.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if( dropDown === "Create K1 Tracker Views and add navigation") {
        showSnackbar({ message: "Create K1 Tracker Views and add navigation triggered." as SnackbarMessage, severity: "info" });
         const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var CpK1Response = await customPermissionClientApi.customPermission_OnDemand(data[0].siteId, data[0].mdmClientId!, "CreateView", "K-1 Tracker");
        if (CpK1Response.success === true) {
          showSuccessSnackbar({ message: CpK1Response.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: CpK1Response.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if( dropDown === "Create Deliverable Views and add navigation") {
        showSnackbar({ message: "Create Deliverable Views and add navigation triggered." as SnackbarMessage, severity: "info" });
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var CpDeliverablesResponse = await customPermissionClientApi.customPermission_OnDemand(data[0].siteId, data[0].mdmClientId!, "CreateView", "Deliverables");
         if (CpDeliverablesResponse.success === true) {
          showSuccessSnackbar({ message: CpDeliverablesResponse.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: CpDeliverablesResponse.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if(dropDown === "Apply IR Permissions") {
        showSnackbar({ message: "Apply IR Permissions triggered." as SnackbarMessage, severity: "info" });
         const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var CpIrPermissionResponse = await customPermissionClientApi.customPermission_OnDemand(data[0].siteId, data[0].mdmClientId!, "UpdateViewPermission", "Information Request List");
         if (CpIrPermissionResponse.success === true) {
          showSuccessSnackbar({ message: CpIrPermissionResponse.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: CpIrPermissionResponse.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if(dropDown === "Apply PS Permissions") {
        showSnackbar({ message: "Apply PS Permissions triggered." as SnackbarMessage, severity: "info" });
         const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var CpPsPermissionResponse = await customPermissionClientApi.customPermission_OnDemand(data[0].siteId, data[0].mdmClientId!, "UpdateViewPermission", "Project Status");
         if (CpPsPermissionResponse.success === true) {
          showSuccessSnackbar({ message: CpPsPermissionResponse.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: CpPsPermissionResponse.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if(dropDown === "Apply K1 Tracker Permissions") {
        showSnackbar({ message: "Apply K1 Tracker Permissions triggered." as SnackbarMessage, severity: "info" });
         const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var CpK1TrackerPermissionResponse = await customPermissionClientApi.customPermission_OnDemand(data[0].siteId, data[0].mdmClientId!, "UpdateViewPermission", "K-1 Tracker");
         if (CpK1TrackerPermissionResponse.success === true) {
          showSuccessSnackbar({ message: CpK1TrackerPermissionResponse.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: CpK1TrackerPermissionResponse.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if(dropDown === "Apply Deliverables Permissions") {
        showSnackbar({ message: "Apply Deliverables Permissions triggered." as SnackbarMessage, severity: "info" });
         const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var CpDeliverablesPermissionResponse = await customPermissionClientApi.customPermission_OnDemand(data[0].siteId, data[0].mdmClientId!, "UpdateViewPermission", "Deliverables");
         if (CpDeliverablesPermissionResponse.success === true) {
          showSuccessSnackbar({ message: CpDeliverablesPermissionResponse.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: CpDeliverablesPermissionResponse.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if( dropDown === "Send Email for failures and successes") {
        showSnackbar({ message: "Send Email for failures and successes triggered." as SnackbarMessage, severity: "info" });
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            mdmClientId: e.mdmClientId,
          };
        });
        var Emailresponse = await customPermissionClientApi.customPermission_EmailNotification(data[0].siteId);
        if (Emailresponse.success === true) {
          showSuccessSnackbar({ message: Emailresponse.message as SnackbarMessage });
        } else {
          showSnackbar({
            message: Emailresponse.message as SnackbarMessage,
            severity: "error",
          });
        }
      }
      if (dropDown === SelectCustomPermission.UPDATE_FOLDER_PERMISSIONS) {
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            userName: user?.profile.preferred_username,
            mdmClientId: e.mdmClientId,
          };
        });
        var response = await taxPortalClientApi.taxPortal_UpdateFolderPermission(data);
        if (response === true) {
          showSuccessSnackbar({ message: SnackbarMessage.FOLDER_PERMISSION_UPDATE });
        } else {
          showSnackbar({
            message: SnackbarMessage.FOLDER_PERMISSION_UPDATE_FAIL,
            severity: "error",
          });
        }
      }
      if (dropDown === SelectCustomPermission.UPDATE_IRVIEW_PERMISSIONS) {
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            userName: user?.profile.preferred_username,
            mdmClientId: e.mdmClientId,
            isheetType: "IR"
          };
        });
        var response = await taxPortalClientApi.highQ_UpdateViewPermissions(data);
        if (response === true) {
          showSuccessSnackbar({ message: SnackbarMessage.VIEW_PERMISSION_UPDATE });
        } else {
          showSnackbar({
            message: SnackbarMessage.VIEW_PERMISSION_UPDATE_FAIL,
            severity: "error",
          });
        }
      }
      if (dropDown === SelectCustomPermission.UPDATE_PSVIEW_PERMISSIONS) {
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            userName: user?.profile.preferred_username,
            mdmClientId: e.mdmClientId,
            isheetType: "PS"
          };
        });
        var response = await taxPortalClientApi.highQ_UpdateViewPermissions(data);
        if (response === true) {
          showSuccessSnackbar({ message: SnackbarMessage.VIEW_PERMISSION_UPDATE });
        } else {
          showSnackbar({
            message: SnackbarMessage.VIEW_PERMISSION_UPDATE_FAIL,
            severity: "error",
          });
        }
      }
      if (dropDown == SelectCustomPermission.EMAIL_FAILURE) {
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            userName: user?.profile.preferred_username,
            mdmClientId: e.mdmClientId,
          };
        });
        var response = await taxPortalClientApi.highQ_SendEmailCustomPermissions(data);
        if (response === true) {
          showSuccessSnackbar({ message: SnackbarMessage.EMAIL_CUSTOMPERMISSIONS });
        } else {
          showSnackbar({
            message: SnackbarMessage.EMAIL_CUSTOMPERMISSIONS_FAIL,
            severity: "error",
          });
        }
      }
      if (dropDown === SelectCustomPermission.UPDATE_K1_TRACKER_PERMISSIONS) {
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            userName: user?.profile.preferred_username,
            mdmClientId: e.mdmClientId,
            isheetType: "K1"
          };
        });
        var response = await taxPortalClientApi.highQ_UpdateViewPermissions(data);
        if (response === true) {
          showSuccessSnackbar({ message: SnackbarMessage.VIEW_PERMISSION_UPDATE });
        } else {
          showSnackbar({
            message: SnackbarMessage.VIEW_PERMISSION_UPDATE_FAIL,
            severity: "error",
          });
        }
      }
      if (dropDown === SelectCustomPermission.UPDATE_DELIVERABLES_PERMISSIONS) {
        const data = selectedData.map((e: GetAllSitesInfoDTO): ServiceMessage => {
          return {
            siteId: e.hqSiteId,
            userName: user?.profile.preferred_username,
            mdmClientId: e.mdmClientId,
            isheetType: "DELIVERABLES"
          };
        });
        var response = await taxPortalClientApi.highQ_UpdateViewPermissions(data);
        if (response === true) {
          showSuccessSnackbar({ message: SnackbarMessage.VIEW_PERMISSION_UPDATE });
        } else {
          showSnackbar({
            message: SnackbarMessage.VIEW_PERMISSION_UPDATE_FAIL,
            severity: "error",
          });
        }
      }
      clearSelection();
    } catch (error) {
      showSnackbar({ message: SnackbarMessage.ERROR, severity: "error" });
    }
  };
  const handleChange = (e: SelectChangeEvent) => {
    const val = e.target.value;
    if (isPartitionLabel(val)) return;
    setDropDown(val);
  };
  const handleIURClick = async () => {
    let type = 0;
    if (appName === "TP") {
      type = ServiceBusEnum.INTERNAL_USER_ASSIGNMENT;
    }
    if (appName === "PERF") {
      type = ServiceBusEnum.INTERNAL_USER_ASSIGNMENT;
    }
    if (appName === "CS") {
      type = ServiceBusEnum.INTERNAL_USER_ASSIGNMENT_CS;
    }
    const message: TpacRequestBasicMessage[] = selectedData.map((e: any) => {
      return {
        hqSiteId: e.hqSiteId,
        appName: appName,
        iSheetType: "Internal User Request Form",
      } as TpacRequestBasicMessage;
    });
    try {
      setSnackbar({
        open: true,
        message: "Internal User Assignment in Progress.",
        severity: "info",
      });
  // Use TPAC trigger API to initiate user assignment instead of direct post
  await userAssignmentClientApi.userAssignment_UserAssignTpacTrigger(UserAssignTpac.TriggerUserAssign, message);
      if (appName === "TP") {
        type = SyncTypeEnum.INTERNAL_USER_ASSIGNMENT;
      }
      if (appName === "CS") {
        type = SyncTypeEnum.INTERNAL_USER_ASSIGNMENT_CS;
      }
      setSyncType(type);
      clearSelection();
    } catch (error) {
      console.log(error);
    }
  };

  const handleIURConsentCheck = async () => {

    try {
      setSnackbar({
        open: true,
        message: "IUR Consent Check in Progress.",
        severity: "info",
      });
      console.log("IURF Consent Check in Progress for option:");
      const checkConsent = selectedData.map((e: any, eventType: any) => {
        return {
          hqSiteId: e.hqSiteId,
          appName: e.appName,
          isheetType: "Internal User Request Form",
          source:"TPAC"
        };
      });

      await userAssignmentClientApi.userAssignment_UserAssignTpacTrigger(UserAssignTpac.TriggerConsentVerification, checkConsent);
      
      clearSelection();
    } catch (error) {
      console.log(error);
    }
  };

  const handleTESSClick = async () => {
    let type = 0;
    if (appName === "IS") {
      const message = selectedData.map((e: any) => {
        return {
          siteId: e.hqSiteId,
          userName: user?.profile.preferred_username,
          eventType: ServiceBusEnum.TESS_ASSIGNMENT,
        };
      });
      try {
        setSnackbar({
          open: true,
          message: "TESS Assignment in Progress.",
          severity: "info",
        });
        await taxPortalClientApi.taxPortal_InsertTopic(message);
        type = ServiceBusEnum.TESS_ASSIGNMENT;
        setSyncType(type);
        clearSelection();
      } catch (error) {
        console.log(error);
      }
    }
  };
  const handleRoleClick = async (roleId: string, roleName: string) => {
    const message = selectedData.map((e: any) => ({
      siteId: e.hqSiteId,
      userName: user?.profile.preferred_username as string,
      eventType: ServiceBusEnum.PROVIDE_APP_ACCESS,
      roleId: roleId,
      roleName: roleName,
    }));
    try {
      setSnackbar({
        open: true,
        message: "Provide Site Role access in Progress.",
        severity: "info",
      });
      await taxPortalClientApi.taxPortal_ProvideAppAccess(message);
      setSyncType(SyncTypeEnum.CLIENT_LEVEL_ROLE_ASSIGN);
      clearSelection();
    } catch (error) {
      console.log(error);
    }
  };

  const handleTESSForIsClick = async () => {
    setSnackbar({
      open: true,
      message: "Provide User Group Access In Progress",
      severity: "info",
    });
    try {
      // Use TPAC trigger API instead of direct internalSite_AddUserGroupUsersToIs call
      const message: TpacRequestBasicMessage[] = selectedData.map((e: any) => {
        return {
          hqSiteId: e.hqSiteId,
          appName: appName,
          iSheetType: "Internal User Request Form",
        } as TpacRequestBasicMessage;
      });
      
      await userAssignmentClientApi.userAssignment_UserAssignTpacTrigger(UserAssignTpac.TriggerUserAssign, message);
      
      // Old code commented out:
      // await Promise.all(
      //   selectedData.map(async (e) => {
      //     await taxPortalClientApi.internalSite_AddUserGroupUsersToIs(
      //       e.hqSiteId,
      //       user?.profile.preferred_username as string
      //     );
      //   })
      // );
      
      setSetsyncTypeIs(SyncTypeEnum.PROVIDE_USERGROUP_ACCESS);
      clearSelection();
    } catch (error) {
      console.log(error);
    }
  };

  const handleTESSIsheet = async () => {
    setSnackbar({
      open: true,
      message: "Provide User TESS Access In Progress",
      severity: "info",
    });

    // const data = selectedData.map(
    //   (e: GetAllSitesDTO): ServiceMessage => ({
    //     siteId: e.hqSiteId,
    //     userName: user?.profile.preferred_username,
    //     eventType: ServiceBusEnum.TESS_ISHEET_ASSIGNMENT,
    //   })
    // );
    // await taxPortalClientApi.taxPortal_InsertTopic(data);
    const message: TpacRequestBasicMessage[] = selectedData.map((e: any) => {
        return {
          hqSiteId: e.hqSiteId,
          appName: appName,
          iSheetType: "TESS User Request Form",
        } as TpacRequestBasicMessage;
      });
      
    await userAssignmentClientApi.userAssignment_UserAssignTpacTrigger(UserAssignTpac.TessRoleAssignInitiate, message);

    setSetsyncTypeIs(SyncTypeEnum.TESS_ISHEET_ASSIGNMENT);
    clearSelection();
  };

  const handleClickApp = async (option: string) => {
    const message = JSON.parse(
      `{"userName" :"${user?.profile.preferred_username as string
      }", "ApplicationGroupType" : "${option}"}`
    );
    try {
      setSnackbar({
        open: true,
        message: "Provide Application access in Progress.",
        severity: "info",
      });
      await taxPortalClientApi.taxPortal_ProvideTESSAccess(message);
      clearSelection();
    } catch (error) {
      console.log(error);
    }
  };
  const handleSyncClick = async (): Promise<void> => {
    try {
      showSnackbar({ message: SnackbarMessage.HANDLE_USER_SYNC.replace('%%', 'STARTED') as SnackbarMessage });
      await taxPortalClientApi.highQ_SyncUsers();
      showSnackbar({ message: SnackbarMessage.HANDLE_USER_SYNC.replace('%%', 'SUCCESS') as SnackbarMessage });
    }
    catch (er) {
      showSnackbar({ message: SnackbarMessage.HANDLE_USER_SYNC.replace('%%', 'FAILED') as SnackbarMessage });
    }
  };


  const handleExternalUser = async (option: string) => {

    const getEventType = (
      appName: string | null | undefined,
      option: string
    ) => {
      if (isNull(appName) || isEmpty(appName) || appName === "TP") {
        switch (option) {
          case "Client User Requests":
          case "External User":
            return ServiceBusEnum.CREATE_EXTERNAL_USER;
          case "Check Status":
            return ServiceBusEnum.CHECK_EXTERNAL_USER_STATUS;
        }
      } else {
        switch (option) {
          case "Client User Requests":
          case "External User":
            return ServiceBusEnum.CREATE_EXTERNAL_USER_CS;
          case "Check Status":
            return ServiceBusEnum.CHECK_EXTERNAL_USER_STATUS;
        }
      }
    };

    const callServiceBus = async (e: any, eventType: any, opt: string) => {
      if (opt === "Check Status") {
        // Updated to use UserAssignTpacTrigger with TriggerCheckStatus
        const payload: TpacRequestBasicMessage[] = [
          {
            hqSiteId: e.hqSiteId,
            appName: e.appName,
            iSheetType: "Client User Requests",
          },
        ];
        await userAssignmentClientApi.userAssignment_UserAssignTpacTrigger(UserAssignTpac.TriggerCheckStatus, payload);
      } else {
        const payload: TpacRequestBasicMessage[] = [
          {
            hqSiteId: e.hqSiteId,
            appName: e.appName,
            iSheetType: "Client User Requests",
          },
        ];
        await userAssignmentClientApi.userAssignment_UserAssignTpacTrigger(UserAssignTpac.TriggerUserAssign, payload);
      }
      clearSelection();
    };

    switch (option) {
      case "Client User Requests":
      case "External User":
      case "Check Status":
        selectedData.forEach((e: any) => {
          const eventType = getEventType(e.appName, option);
          callServiceBus(e, eventType, option);
        });
        break;
      default:
        // Handle unexpected option
        break;
    }

    let snackbarMessage = "";
    switch (option) {
      case "Client User Requests":
      case "External User":
        snackbarMessage = "Client User Request in Progress.";
        break;
      case "Check Status":
        snackbarMessage = "Check Status in Progress.";
        break;
      default:
        snackbarMessage = "Operation in Progress.";
        break;
    }

    setSnackbar({
      open: true,
      message: snackbarMessage,
      severity: "info",
    });

    if (isNull(appName) || isEmpty(appName) || appName === "TP") {
      setSyncType(SyncTypeEnum.CREATE_EXTERNAL_USER);
    } else {
      setSyncType(SyncTypeEnum.CREATE_EXTERNAL_USER_CS);
    }

    try {
      // Add your try-catch logic here if needed
    } catch (error) {
      console.log(error);
    }
  };

  const handleThirdPartyUser = async (option: string) => {

    const getEventType = (
      appName: string | null | undefined,
      option: string
    ) => {
      if (isNull(appName) || isEmpty(appName) || appName === "TP" || appName === "CS") {
        switch (option) {
          case "Third Party User Isheet":
          case "Third-Party User":
            return ServiceBusEnum.CREATE_EXTERNAL_USER_THIRD_PARTY;
          case "Check Status":
            return ServiceBusEnum.CHECK_EXTERNAL_USER_STATUS;
        }
      }
    };

    const callServiceBus = async (e: any, eventType: any, opt: string) => {
      if (opt === "Check Status") {
        // Updated to use UserAssignTpacTrigger with TriggerCheckStatus
        const payload: TpacRequestBasicMessage[] = [
          {
            hqSiteId: e.hqSiteId,
            appName: e.appName,
            iSheetType: "Third-party User Request Form",
          },
        ];
        await userAssignmentClientApi.userAssignment_UserAssignTpacTrigger(UserAssignTpac.TriggerCheckStatus, payload);
        clearSelection();
      } else {
        const payload: TpacRequestBasicMessage[] = [
          {
            hqSiteId: e.hqSiteId,
            appName: e.appName,
            iSheetType: "Third-party User Request Form",
          },
        ];
        await userAssignmentClientApi.userAssignment_UserAssignTpacTrigger(UserAssignTpac.TriggerUserAssign, payload);
        clearSelection();
      }
    };

    switch (option) {
      case "Third Party User Isheet":
      case "Third-Party User":
      case "Check Status":
        selectedData.forEach((e: any) => {
          const eventType = getEventType(e.appName, option);
          callServiceBus(e, eventType, option);
        });
        break;
      default:
        // Handle unexpected option
        break;
    }

    let snackbarMessage = "";
    switch (option) {
      case "Third Party User Isheet":
      case "Third-Party User":
        snackbarMessage = "Third-Party User Request in Progress.";
        break;
      case "Check Status":
        snackbarMessage = "Check Status in Progress.";
        break;
      default:
        snackbarMessage = "Operation in Progress.";
        break;
    }

    setSnackbar({
      open: true,
      message: snackbarMessage,
      severity: "info",
    });

    setSyncType(SyncTypeEnum.CREATE_EXTERNAL_USER_THIRD_PARTY);
  };
  const handleMemberFirmUser = async (option: string) => {

    const getEventType = (
      appName: string | null | undefined,
      option: string
    ) => {
      if (isNull(appName) || isEmpty(appName)) {
        switch (option) {
          case "Member Firm User Isheet":
          case "Member Firm User":
            return ServiceBusEnum.MEMBER_FIRM;
          case "Check Status":
            return ServiceBusEnum.CHECK_EXTERNAL_USER_STATUS;
        }
      }
    };

    const callServiceBus = async (e: any, eventType: any, opt: string) => {
      if (opt === "Check Status") {
        // Updated to use UserAssignTpacTrigger with TriggerCheckStatus
        const payload: TpacRequestBasicMessage[] = [
          {
            hqSiteId: e.hqSiteId,
            appName: e.appName,
            iSheetType: "Member Firm User Request Form",
          },
        ];
        await userAssignmentClientApi.userAssignment_UserAssignTpacTrigger(UserAssignTpac.TriggerCheckStatus, payload);
      } else {
        // TPAC trigger for create/request flows
        const payload: TpacRequestBasicMessage[] = [
          {
            hqSiteId: e.hqSiteId,
            appName: e.appName,
            iSheetType: "Member Firm User Request Form",
          },
        ];
        await userAssignmentClientApi.userAssignment_UserAssignTpacTrigger(UserAssignTpac.TriggerUserAssign, payload);
      }
      clearSelection();
    };

    switch (option) {
      case "Member Firm User Isheet":
      case "Member Firm User":
      case "Check Status":
        selectedData.forEach((e: any) => {
          const eventType = getEventType(e.appName, option);
          callServiceBus(e, eventType, option);
        });
        break;
      default:
        // Handle unexpected option
        break;
    }

    let snackbarMessage = "";
    switch (option) {
      case "Member Firm User Isheet":
      case "Member Firm User":
        snackbarMessage = "Member Firm User Request in Progress.";
        break;
      case "Check Status":
        snackbarMessage = "Check Status in Progress.";
        break;
      default:
        snackbarMessage = "Operation in Progress.";
        break;
    }

    setSnackbar({
      open: true,
      message: snackbarMessage,
      severity: "info",
    });

    setSyncType(SyncTypeEnum.CREATE_EXTERNAL_USER_THIRD_PARTY);
    clearSelection();
  };

  const cellRenderSiteCreated = (e: any) => {
    return <div>{convertUTCTimeToLocal(e.data.siteCreated)}</div>;
  };
  const cellRenderLastUpdate = (e: any) => {
    return <div>{convertUTCTimeToLocal(e.data.lastModified)}</div>;
  };
  const onSelectionChanged = (e: any) => {
    try {

        const newPageKeys = e.selectedRowKeys;
        const newPageData = e.selectedRowsData;
        const visibleKeys = e.component?.getVisibleRows()?.map((row: any) => row.key) || [];

        const addedKeys = newPageKeys.filter((key: any) => !prevKeysRef.current.includes(key));
        const addedData = newPageData.filter((row: any) => addedKeys.includes(row.hqSiteId));
        const removedKeys = visibleKeys.filter((k: any) => prevKeysRef.current.includes(k) && !newPageKeys.includes(k));

        const updatedKeys = [
            ...prevKeysRef.current.filter((k: any) => !removedKeys.includes(k)),
            ...addedKeys,
        ];

        const updatedData = [
            ...prevDataRef.current.filter((row: any) => !removedKeys.includes(row.hqSiteId)),
            ...addedData,
        ];

        prevKeysRef.current = updatedKeys;
        prevDataRef.current = updatedData;

        setSelectedRowKeys(updatedKeys);
        setSelectedData(updatedData);
    } catch (error) {
        clearSelection();
    }
};

const clearSelection = () => {
    setSelectedRowKeys([]);
    setSelectedData([]);
    prevKeysRef.current = [];
    prevDataRef.current = [];
};

  const refreshButtonOptions = {
    icon: "refresh",
    onClick: async () => {
      setSearchTerm(null);
      if (dataGridRef.current) {
        dataGridRef.current.instance.clearFilter();
      }
      clearSelection();
      fetchSites();
    },
  };

  const fetchSitesBySearchTerms = async () => {
    try {
      setData({ pending: true, fulfilled: false, sites: [], totalCount: 0 });
      const res = await createSitesClientApi.taxPortal_GetAllSiteSearch(
        SyncTypeEnum.SITE_ADMIN_ACCESS,
        appName !== null ? appName : "PERF",
        searchTerm
      );
      if (res != null) {
        setData({
          pending: false,
          fulfilled: true,
          sites: res.data,
          totalCount: res.totalCount,
        });
      } else {
        setData({ pending: false, fulfilled: true, sites: [], totalCount: 0 });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!isNull(searchTerm) && !isEmpty(searchTerm)) {
        clearSelection();
      fetchSitesBySearchTerms();
    }
    // eslint-disable-next-line
  }, [appName, searchTerm]);
  useEffect(() => {
    clearSelection();
}, [appName]);

  return (
    <div className="site-admin-container">
      <div
        style={{
          display: "flex",
          margin: "10px 0 10px 0",
        }}
      >
        <h2>Assign Users</h2>
        <AppNameToggle />
      </div>
      <DataGrid
        keyExpr="hqSiteId"
        height={calculateGridHeight(254)}
        onSelectionChanged={onSelectionChanged}
        selectedRowKeys={selectedRowKeys}
        {...dataGridConfig}
        dataSource={data.sites}
        noDataText={data.pending ? "Loading..." : "No data"}
        ref={dataGridRef}
        repaintChangesOnly={false}
      >
        <Selection
          mode="multiple"
          selectAllMode={"page"}
          showCheckBoxesMode={"always"}
        />
        <Scrolling mode="standard" />
        <LoadPanel enabled={false} />
        <SearchPanel
          placeholder={"Global Search..."}
          onTextChange={(e) => {
            setSearchTerm(e);
          }}
          visible
        />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        <Scrolling columnRenderingMode="virtual" />
        <Toolbar>
        <Item location="start">
                        <div className="counter">
                            <h4>
                                {data.pending
                                    ? "Loading..."
                                    : `${selectedData.length} out of ${data.totalCount} records selected`}
                            </h4>
                        </div>
                    </Item>
          {appName != "PERF" && (
            <Item key="nestedDropDown" location="after">
              <NestedDropDownV2
                rolesData={rolesData}
                provideAccess={selectedData.length > 0 ? false : true}
                handleRoleClick={handleRoleClick}
                handleClickApp={handleClickApp}
                handleExternalUser={handleExternalUser}
                handleThirdPartyUser={handleThirdPartyUser}
                appName={appName}
                handleIURClick={handleIURClick}
                handleMemberFirmUser={handleMemberFirmUser}
                handleTESSForIsClick={handleTESSForIsClick}
                handleTESSIsheet={handleTESSIsheet}
                handleIURConsentCheck={handleIURConsentCheck}
              />
            </Item>
          )}
          {(appName === "TP" || appName === "CS") && [
            // <Item location="after">
            //   <Button variant="outlined" onClick={handleSyncClick}>Sync Users</Button>
            // </Item>,
              <Item key="formContorl" location="after">
          <FormControl size="small" variant="outlined" sx={{ minWidth: 190 }}>
            <InputLabel id="demo-simple-select-label">Custom Permissions</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={dropDown}
              style={{ height: 36, fontSize: "14px" }}
              label="Custom Permissions"
              onChange={handleChange}
            >
              {/* <MenuItem disabled value={OLD_FLOW_LABEL} style={{ fontWeight: 600, opacity: 1, pointerEvents: "none" }}>
                Old Flow
              </MenuItem>
              {getPermissionsByApp(appName).map((name) => (
                <MenuItem key={name} value={name} style={{ fontSize: "14px" }}>
                  {name}
                </MenuItem>
              ))}
              <MenuItem disabled value={NEW_FLOW_LABEL} style={{ fontWeight: 600, opacity: 1, pointerEvents: "none" }}>
                New Flow
              </MenuItem> */}
              {NEW_FLOW_OPTIONS.map((name) => (
                <MenuItem key={name} value={name} style={{ fontSize: "14px" }}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Item>
          ]}
          <Item location="after">
            <Button variant="outlined" disabled={!(appName === "TP" && selectedData.length > 0)} onClick={handleUpdateClick}>Update Sites</Button>
          </Item>
          {appName === "PERF" && (
            <Item location="after">
              <NestedDropDown
                rolesData={rolesData}
                provideAccess={selectedData.length > 0 ? false : true}
                handleRoleClick={handleRoleClick}
                handleClick={handleClick}
                handleClickApp={handleClickApp}
                handleExternalUser={handleExternalUser}
                handleThirdPartyUser={handleThirdPartyUser}
                handleMemberFirmUser={handleMemberFirmUser}
                appName={appName}
                handleTESSForIsClick={handleTESSForIsClick}
                handleTESSIsheet={handleTESSIsheet}
                handleIURClick={handleIURClick}
                handleTESSClick={handleTESSClick}
              />
            </Item>
          )}
          <Item name="searchPanel" location="after" />
          <Item
            widget="dxButton"
            options={refreshButtonOptions}
            name="alignRight"
          />
        </Toolbar>
        <Column
          width={20}
          alignment="left"
          dataField="hqSiteId"
          caption={"SiteID"}
        ></Column>
        <Column
          width={130}
          alignment="left"
          dataField="mdmClientId"
          caption={"MDMClientID"}
        ></Column>
        <Column
          minWidth={140}
          dataField="hqClientName"
          caption={"SiteName"}
        ></Column>
        <Column
          minWidth={150}
          dataField="siteCreatedBy"
          caption={"Site Created by"}
        ></Column>
        <Column
          minWidth={170}
          cellRender={cellRenderSiteCreated}
          dataField="Site Created Date / Time"
          caption={"Site Created Date / Time"}
        ></Column>

        <Column
          minWidth={140}
          dataField="lastModifiedBy"
          caption={"Last Updated by"}
        ></Column>
        <Column
          minWidth={160}
          cellRender={cellRenderLastUpdate}
          dataField="Last Update Date/Time"
          caption={"Last Update Date/Time"}
        ></Column>
        <Column
          minWidth={140}
          dataField="correlationId"
          caption={"Correlation Id"}
        ></Column>
      </DataGrid>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "5px 0 0 0",
        }}
      >
        <Pagination
          onChange={(e: any, pageNumber: any) => {
            setpageNumber(pageNumber);
          }}
          count={Math.ceil((data.totalCount as number) / defaultPageSize)}
          variant="outlined"
          shape="rounded"
        />
      </div>
    </div>
  );
};

export default SiteAdminAccess;

